import { DocumentScopeEnum } from "api/contract";

export const scopeLabels: Record<string, string> = {
  [DocumentScopeEnum.Quote]: 'DOCUMENT.SCOPE.QUOTE',
  [DocumentScopeEnum.Contract]: 'DOCUMENT.SCOPE.CONTRACT',
  [DocumentScopeEnum.Product]: 'DOCUMENT.SCOPE.PRODUCT',
  [DocumentScopeEnum.Amendment]: 'DOCUMENT.SCOPE.AMENDMENT',
  [DocumentScopeEnum.Receipt]: 'DOCUMENT.SCOPE.RECEIPT',
  [DocumentScopeEnum.Broker]: 'DOCUMENT.SCOPE.BROKER',
  [DocumentScopeEnum.System]: 'DOCUMENT.SCOPE.SYSTEM',
  [DocumentScopeEnum.Tenant]: 'DOCUMENT.SCOPE.TENANT',
  [DocumentScopeEnum.Subscriber]: 'DOCUMENT.SCOPE.SUBSCRIBER',
  [DocumentScopeEnum.BorrowerProject]: 'DOCUMENT.SCOPE.OTHER_DOCUMENTS',
};
